import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import axios from "axios";
import {BOOKING_UPDATE_DATES} from "../../../../constants/api.constants";
import {bookingUpdateDatesConstants} from "../../../../constants/General/bookingUpdateDates.constants";

export function bookingUpdateDates(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                booking_id: params.booking_id,
                checkin_date: params.checkin_date,
                checkout_date: params.checkout_date,
                total: params.total,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'BOOKING_UPDATE_DATES',
            payload: axios.post(BOOKING_UPDATE_DATES, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearBookingUpdateDates() {
    return dispatch => {
        dispatch({
            type: bookingUpdateDatesConstants.BOOKING_UPDATE_DATES_CLEAR,
        })
    }
}
